import { FC, useEffect, useState } from "react";
import { StatusPictureProps } from "./types";
import { Column } from "../containers";
import { JustifyContent } from "../containers/types";
import { Color } from "../../types";
import { UserStatus } from "../../pages/admin-panel/users/types";
import { DEBUG } from "../../api";
import { HOST_USER_FILES } from "../../api/settings";

const GREEN: Color = "#558b2f";
const GREY: Color = "grey";
const BIG_SIZE: number = 52;
const SMALL_SIZE: number = 36;

const StatusPicture: FC<StatusPictureProps> = ({
  src,
  type,
  status = UserStatus.Offline,
  onClick = () => {},
  style = {},
  className = "",
}) => {
  const [size, setSize] = useState(type === "big" ? BIG_SIZE : SMALL_SIZE);
  const [border, setBorder] = useState<string>(
    status === UserStatus.Online ? GREEN : GREY
  );

  useEffect(() => {
    setSize(type === "big" ? BIG_SIZE : SMALL_SIZE);
    setBorder(status === UserStatus.Online ? GREEN : GREY);
  }, [type, status]);

  return (
    <Column
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        border: `2px solid ${border}`,
        cursor: "pointer",
        ...style,
      }}
      justifyContent={JustifyContent.Center}
      className={`transition ${className}`}
      props={{ onClick }}
    >
      <img
        src={DEBUG ? src : `${HOST_USER_FILES}/${src}`}
        alt={"???"}
        style={{
          width: size - 4,
          height: size - 4,
          borderRadius: "50%",
          margin: 2,
          objectFit: "cover",
        }}
      />
    </Column>
  );
};

export default StatusPicture;
